import Vue from "vue";
import UUID from "./uuid";
import VS2 from "vue-script2";

Vue.use(UUID);
Vue.use(VS2);

export default {};
